module.exports = __webpack_public_path__ + "fonts/3a00132.ttf";